import { Action } from "redux"

import * as actions from "./actions"
import { IShortcuts } from "./index"
import { IShortcut } from "../../models"

export const initialState: IShortcuts = {
    shortcuts: {},
    isLoading: false,
    filter: "",
    initialized: false,
    workspaceId: 0,
}

const ACTION_HANDLERS: {
    [action: string]: (state: IShortcuts, props: Action) => IShortcuts
} = {
    [actions.SET_INITIALIZED]: (state): IShortcuts => ({
        ...state,
        initialized: true,
    }),

    [actions.REQUEST_SHORTCUTS]: (state): IShortcuts => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_SHORTCUTS]: (
        state,
        { shortcuts: shortcutsArray }: actions.ReceiveShortcuts,
    ): IShortcuts => {
        const shortcuts: Record<string, IShortcut> = {}
        shortcutsArray.forEach((shortcut) => {
            if (!!shortcut.id) {
                shortcuts[shortcut.id.toString()] = shortcut
            }
        })

        return {
            ...state,
            shortcuts: shortcuts,
            isLoading: false,
        }
    },

    [actions.FILTER_SHORTCUTS]: (
        state,
        { filter }: actions.FilterShortcuts,
    ): IShortcuts => ({ ...state, filter }),
}

export default function reducer(
    state: IShortcuts = initialState,
    action: Action,
): IShortcuts {
    const handler: (state: IShortcuts, action: Action) => IShortcuts =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
